import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitch: React.FC = () => {
  const { i18n } = useTranslation();

  const handleChangeLanguage = useCallback(
    (lng: string) => {
      i18n.changeLanguage(lng);
    },
    [i18n]
  );

  return (
    <div style={{ textAlign: 'right', paddingTop: 5, paddingRight: 30 }}>
      <button
        onClick={() => handleChangeLanguage('de')}
        disabled={i18n.language === 'de'}
        style={{ cursor: i18n.language === 'de' ? 'default' : 'pointer' }}
      >
        DE
      </button>
      <button
        onClick={() => handleChangeLanguage('en')}
        disabled={i18n.language === 'en'}
        style={{ cursor: i18n.language === 'en' ? 'default' : 'pointer' }}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitch;
